export default __webpack_public_path__ + "static/media/itchbook-grey-16px.8e6cbf37.svg";